var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFClothes2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 154,
    viewBox: "0 0 116 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 128V54H23.5V128H0Z",
    fill: "#FAE084"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92 128V54H115.5V128H92Z",
    fill: "#FAE084"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3 13.7V54.3H0V13.7C0 6.1 6.10001 0 13.6 0C21.2 0 27.3 6.1 27.3 13.7V13.7Z",
    fill: "#FAE084"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.8 0C109.4 0 115.5 6.1 115.5 13.7V54.3H88.1001V13.7C88.1001 6.1 94.2001 0 101.8 0V0Z",
    fill: "#FAE084"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77 85.6H61.2H54.5H38.8C9.49999 44 14.4 0 14.4 0H43.9999C53.0964 8.21201 58.3512 8.38995 67.9999 0H101.4C101.4 0 106.2 44 77 85.6Z",
    fill: "#FAE084"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 54.3C22.5 54.3 14.9 37.7 14.5 17",
    stroke: "#E8CA6E",
    strokeWidth: 1.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6001 54.3C93.6001 54.3 101.3 37.7 101.7 17",
    stroke: "#E8CA6E",
    strokeWidth: 1.7
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.9 153.1H58H57.9H11.3C5.39999 105.9 38.8 85.6 38.8 85.6H57.9H58H77.1C77.1 85.6 111.8 106.3 105.9 153.1Z",
    fill: "#03152F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFClothes2);
export default __webpack_public_path__ + "static/media/f-clothes-2.f8d2cfdc17679c4ab4929196bfbb50c2.svg";
export { ForwardRef as ReactComponent };